var $ = require('jquery');

$(function () {

    $('.column-directory-content__list--mobile').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.column-directory-content__list--mobile').slick('resize');
    });

    $('.column-directory-content__show-more-less a').on('click', function (e) {
        e.preventDefault();
        $('.column-directory-content, .column-directory-content__show-more-less__more').toggleClass('show-more');
    });
});
